import { render, staticRenderFns } from "./customerSelector.vue?vue&type=template&id=5a78b76d&scoped=true&"
import script from "./customerSelector.vue?vue&type=script&lang=js&"
export * from "./customerSelector.vue?vue&type=script&lang=js&"
import style0 from "./customerSelector.vue?vue&type=style&index=0&lang=css&"
import style1 from "./customerSelector.vue?vue&type=style&index=1&id=5a78b76d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a78b76d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a78b76d')) {
      api.createRecord('5a78b76d', component.options)
    } else {
      api.reload('5a78b76d', component.options)
    }
    module.hot.accept("./customerSelector.vue?vue&type=template&id=5a78b76d&scoped=true&", function () {
      api.rerender('5a78b76d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customerSelector.vue"
export default component.exports